import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArts } from "../../../actions/arts";
import { getServiceMonitorStatistics } from "../../../actions/connectivity";
import { getProviders } from "../../../actions/providers";
import ServiceMonitorSearchForm from "./serviceMonitorSearchForm";
import ServiceMonitorTable from "./serviceMonitorTable";

const ServiceMonitorSearchContainer = () => {
  const dispatch = useDispatch();
  const providers = useSelector((state) => state.providers.listProviders);

  const art = useSelector((state) => state.arts);

  const novedadesPrestadorConectividad = useSelector(
    (state) => state.connectivity.serviceMonitorStatistics,
  );

  const tableData = useMemo(() => {
    return novedadesPrestadorConectividad.data.filter(i => i.statistics).map((i) => (i.statistics));
  }, [novedadesPrestadorConectividad.data]);

  const loading = providers.isFetching || art.isFetching;
  const tableLoading =
    novedadesPrestadorConectividad.isFetching;

  const [filters, setFilters] = useState(null);


  useEffect(() => {
    dispatch(getProviders());
    dispatch(getArts());
  }, []);

  const handleSubmitSearch = ({ art }) => {
    dispatch(getServiceMonitorStatistics(art));
    setFilters(values);
  };

  return (
    <>
      <ServiceMonitorSearchForm
        loading={loading}
        arts={art.list}
        model={filters}
        handleSubmitSearch={handleSubmitSearch}
      />
      <ServiceMonitorTable
        loading={tableLoading}
        data={tableData}
      />

    </>
  );
};

export default ServiceMonitorSearchContainer;
